export const OFF_PAGE_MASK_OPACITY = 0.45;

export function isFullyInsidePage(objectBounds, pageBounds) {
    if (!objectBounds || !pageBounds) return true;
    return objectBounds.x >= pageBounds.x &&
        objectBounds.y >= pageBounds.y &&
        objectBounds.x + objectBounds.width <= pageBounds.x + pageBounds.width &&
        objectBounds.y + objectBounds.height <= pageBounds.y + pageBounds.height;
}

export function computeOffPageMaskRects(viewBounds, pageBounds) {
    if (!viewBounds || !pageBounds) return {};
    const viewRight = viewBounds.x + viewBounds.width;
    const viewBottom = viewBounds.y + viewBounds.height;
    const pageRight = pageBounds.x + pageBounds.width;
    const pageBottom = pageBounds.y + pageBounds.height;

    return {
        top: {
            x: viewBounds.x,
            y: viewBounds.y,
            width: viewBounds.width,
            height: Math.max(0, pageBounds.y - viewBounds.y),
            visible: pageBounds.y > viewBounds.y,
        },
        left: {
            x: viewBounds.x,
            y: pageBounds.y,
            width: Math.max(0, pageBounds.x - viewBounds.x),
            height: pageBounds.height,
            visible: pageBounds.x > viewBounds.x,
        },
        right: {
            x: pageRight,
            y: pageBounds.y,
            width: Math.max(0, viewRight - pageRight),
            height: pageBounds.height,
            visible: viewRight > pageRight,
        },
        bottom: {
            x: viewBounds.x,
            y: pageBottom,
            width: viewBounds.width,
            height: Math.max(0, viewBottom - pageBottom),
            visible: viewBottom > pageBottom,
        },
    };
}
